import { combineReducers } from "redux";
import assessment from "pages/teacher/assessments/questions/duck";
import standards from "pages/teacher/standards/duck";
import highlighting from "components/toolbar/components/actions/components/highlighting/duck";
import otherScores from "pages/teacher/students/components/sections/show/components/students/components/table/duck";
import toolbar from "components/toolbar/components/actions/duck";
import lti from "pages/lti/duck";
import authReducer from "./auth";
import offlineMode from "./offline-mode";

export default combineReducers({
  auth: authReducer,
  assessment,
  standards,
  highlighting,
  toolbar,
  offlineMode,
  lti,
  otherScores,
});
